'use client';

import cx from 'classnames';
import { useController } from 'react-hook-form';
import styles from './styles.module.css';

interface ToggleSwitcherProps {
  name: string;
  control?: any;
  defaultValue?: string | boolean;
  value?: string | boolean;
  onChange?: (value: string | boolean) => void;
  leftLabel?: string;
  rightLabel?: string;
  className?: string;
  size?: 'small' | 'default';
}

const ToggleSwitcher = ({
  name,
  control,
  defaultValue = '0',
  value: propValue,
  onChange: propOnChange,
  className,
  size = 'default',
}: ToggleSwitcherProps) => {
  const useFormControl = control !== undefined;

  let value = propValue;
  let onChange = propOnChange;

  if (useFormControl) {
    // eslint-disable-next-line
    const { field } = useController({
      name,
      control,
      defaultValue,
    });

    value = field.value;
    onChange = field.onChange;
  }

  const isChecked = value === '1' || value === 'true' || value === true;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.checked ? '1' : '0';
    if (onChange) onChange(newValue);
  };

  return (
    <div>
      <label
        className={cx(
          styles.toggleSwitcher,
          size === 'small' && styles.small,
          className,
        )}
      >
        <input type="checkbox" checked={isChecked} onChange={handleChange} />
        <span className={styles.slider}></span>
      </label>
    </div>
  );
};

export default ToggleSwitcher;
